module.exports = __webpack_public_path__ + "img/A3.a65e8f66.png";